webpackJsonp([173571495296955],{

/***/ 1963:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProviderCommission","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"percent","type":{"kind":"SCALAR","name":"Decimal","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"productType","type":{"kind":"OBJECT","name":"ProductType","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-provider-commission-93b95b5304906d50b4c2.js